<template>
  <div :id="`link_point_${destination}`" class="link-point"></div>
</template>

<script>
export default {
	name: 'LinkPoint',
  props: {
    destination: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
.link-point {
	position: absolute;
	top: -80px;
}
@media screen and (max-width: 896px) {
	.link-point {
		position: absolute;
		top: -40px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/LinkPoint.vue